import request from '@/plugins/axios'

export function listApi(params) {
  // 分页获取
  return request({
    url: `/mark/facebook_accounts`,
    method: 'get',
    params
  })
}
export function addApi(data) {
  // 新增Facebook账号标签
  return request({
    url: `/mark/facebook_accounts`,
    method: 'post',
    data
  })
}
export function batch_tagApi(facebook_account_id, ids) {
  // Facebook账号多个标签
  return request({
    url: `/mark/facebook_accounts/${facebook_account_id}:batch_tag`,
    method: 'post',
    data: {
      ids: ids
    }
  })
}
export function detailApi(id) {
  // 获取指定Facebook账号标签
  return request({
    url: `/mark/facebook_accounts/${id}`,
    method: 'get'
  })
}
export function delApi(id) {
  // 删除
  return request({
    url: `/mark/facebook_accounts/${id}`,
    method: 'delete'
  })
}
// 批量更新账号标签
export function batchTagApi(id, data) {
  // 删除
  return request({
    url: `/mark/facebook_accounts/${id}:batch_update_tag`,
    method: 'post',
    data
  })
}
